module.exports = __webpack_public_path__ + "public/files/img/barcode.577c23de.png";